import { render, staticRenderFns } from "./ChannelPartnerHeader.vue?vue&type=template&id=181f3315&"
import script from "./ChannelPartnerHeader.vue?vue&type=script&lang=js&"
export * from "./ChannelPartnerHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports